import type { ChatMessage, MCPStreamEvent, MessageStatus } from "@/types";

const updateMessage = (
  messages: ChatMessage[],
  messageId: string,
  updater: (message: ChatMessage) => ChatMessage,
): ChatMessage[] =>
  messages.map(message => (message.id === messageId ? updater(message) : message));

export const appendToMessage = (messages: ChatMessage[], messageId: string, delta: string): ChatMessage[] =>
  updateMessage(messages, messageId, message => ({
    ...message,
    content: `${message.content}${delta}`,
  }));

export const setMessageStatus = (
  messages: ChatMessage[],
  messageId: string,
  status: MessageStatus,
  fallbackContent?: string,
): ChatMessage[] =>
  updateMessage(messages, messageId, message => ({
    ...message,
    status,
    content: fallbackContent ? fallbackContent : message.content,
  }));

export const applyStreamEvent = (
  messages: ChatMessage[],
  streamingMessageId: string,
  event: MCPStreamEvent,
): ChatMessage[] => {
  if (event.type === "delta" || event.type === "message") {
    const delta = typeof event.data === "string" ? event.data : JSON.stringify(event.data ?? "");
    return appendToMessage(messages, streamingMessageId, delta);
  }

  if (event.type === "error") {
    const errorText = typeof event.data === "string" ? event.data : "Unable to complete the request.";
    return setMessageStatus(messages, streamingMessageId, "error", errorText);
  }

  if (event.type === "done") {
    return setMessageStatus(messages, streamingMessageId, "sent");
  }

  return messages;
};
